import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  GetSenderImageParams,
  GetSenderImageResponse,
  ProblemDetails
} from '../../models';

import { useCustomNotificationsClient } from '../../custom-client.tsx';
import type { ErrorType } from '../../custom-client.tsx';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get the sender image<br><br><b>Required Scopes</b><br>notifications.doka.com/notifications.inbox<br>notifications.doka.com/notifications.send
 */
export const useGetSenderImageHook = () => {
        const getSenderImage = useCustomNotificationsClient<GetSenderImageResponse>();

        return useCallback((
    trackingId: string,
    params?: GetSenderImageParams,
 signal?: AbortSignal
) => {


        return getSenderImage(
          {url: `/messages/${trackingId}/sender-image`, method: 'GET',
        params, signal
    },
          );
        }, [getSenderImage])
      }




export const getGetSenderImageQueryKey = (trackingId: string,
    params?: GetSenderImageParams,) => {
    return [
    `/messages/${trackingId}/sender-image`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetSenderImageQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError = ErrorType<ProblemDetails>>(trackingId: string,
    params?: GetSenderImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSenderImageQueryKey(trackingId,params);

  const getSenderImage =  useGetSenderImageHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>> = ({ signal }) => getSenderImage(trackingId,params, signal);





   return  { queryKey, queryFn, enabled: trackingId !== null && trackingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSenderImageQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>>
export type GetSenderImageQueryError = ErrorType<ProblemDetails>


export function useGetSenderImage<TData = Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError = ErrorType<ProblemDetails>>(
 trackingId: string,
    params: undefined |  GetSenderImageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSenderImage<TData = Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError = ErrorType<ProblemDetails>>(
 trackingId: string,
    params?: GetSenderImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSenderImage<TData = Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError = ErrorType<ProblemDetails>>(
 trackingId: string,
    params?: GetSenderImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSenderImage<TData = Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError = ErrorType<ProblemDetails>>(
 trackingId: string,
    params?: GetSenderImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSenderImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSenderImageQueryOptions(trackingId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






